import { render, staticRenderFns } from "./OfficerInfo.vue?vue&type=template&id=1bc554d2"
import script from "./OfficerInfo.vue?vue&type=script&lang=js"
export * from "./OfficerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports